import { clsx } from 'clsx';
import { FC, JSX } from 'react';

import { useApplicationContext } from 'shared/context/ApplicationContext';
import { useListingLayoutIsShortSelector } from 'shared/store/clientSide/slices/listingLayout';

import { AdfoxSEOBottomBannersLoadable } from '../AdfoxSEOBottomBanners/AdfoxSEOBottomBannersLoadable';
import { ChatPopupContainer } from '../ChatPopup';
import { CrosslinksContainer } from '../Crosslinks';
import { ApplicationListingContainer } from '../ListingLayout';
import { MapLayoutContainer } from '../MapLayout/MapLayoutContainer';
import { MarkedListContainer } from '../MarkedList';
import { RenderInViewPort } from '../RenderInViewPort';
import { TopHitsLinksContainer } from '../TopHitsLinks';

import { ELEMENTS_IDS } from './constants/elements-ids';
import { Section } from './internal/components/Section';
import { SectionWithMap } from './internal/components/SectionWithMap';

import styles from './ApplicationLayout.css';

export const ApplicationLayout: FC = () => {
  const { config } = useApplicationContext();
  const isMapOpen = useListingLayoutIsShortSelector();
  /**
   * @todo Удалить RSку
   * @description Данный функционал появился в задаче CD-173365, будет удалён в задаче CD-173955
   */
  const listingMapEnabled = config.getStrict<boolean>('Commercial.NewListingMap.Enabled');

  return (
    <main className={styles['container']}>
      {listingMapEnabled ? (
        <SectionWithMap isShort={isMapOpen} map={<MapLayoutContainer />}>
          <div
            className={clsx(styles['main-content'], isMapOpen && styles['is-short'])}
            id={ELEMENTS_IDS.listingNodeId}
          >
            <ApplicationListingContainer />
            <ChatPopupContainer />
          </div>
        </SectionWithMap>
      ) : (
        <Section>
          <div className={styles['main-content']}>
            <ApplicationListingContainer />
            <ChatPopupContainer />
          </div>
        </Section>
      )}
      <Section bgc="gray">
        <div className={styles['footer-content']}>
          <TopHitsLinksContainer />
          <CrosslinksContainer />
          <RenderInViewPort>{(): JSX.Element => <AdfoxSEOBottomBannersLoadable />}</RenderInViewPort>
          <MarkedListContainer />
        </div>
      </Section>
    </main>
  );
};
